/**
 * 別ドメインでホストされた Webpack chunk されたjsコードを正しくLoadするためのワザ
 * https://github.com/webpack/webpack/issues/7077
 * Do not delete this
 */
import '../public-path'
import './assets/scss/index.scss'
import Vue from 'vue'
import { $AxE2Loader } from './services/$AxE2Loader'
import './services/loadCommonVueComponent'
import { $AxE2Config } from './services/$AxE2Config'
import { $axFrontendHelper } from './services/$axFrontendHelper'
import { $AxE2 } from './services/$AxE2'
import { $toast } from './services/$toast'
import { $util } from '@shared/nuxt/plugins/$util'
import { $axItemSearchHelper } from './services/$axItemSearchHelper'
import { $itemFavoriteManager } from './services/$itemFavoriteManager'
import './services/vueFilters'
import * as actions from './actions/hooks'

Vue.prototype.$AxE2Config = $AxE2Config
Vue.prototype.$axFrontendHelper = $axFrontendHelper
Vue.prototype.$api = $axFrontendHelper
Vue.prototype.$config = {
  env: process.env.NODE_ENV,
}
Vue.prototype.$AxE2 = $AxE2
Vue.prototype.$A = Vue.prototype.$AxE2 // alias of
Vue.prototype.$toast = $toast
Vue.prototype.$util = $util
Vue.prototype.$models = $AxE2.$config.$models
Vue.prototype.$appHook = $AxE2.$appHook
Vue.prototype.$axItemSearchHelper = $axItemSearchHelper
Vue.prototype.$itemFavoriteManager = $itemFavoriteManager

Vue.config.productionTip = false

declare module 'vue/types/vue' {
  interface Vue {
    $AxE2Config: typeof $AxE2Config
    $axFrontendHelper: typeof $axFrontendHelper
    $AxE2: typeof $AxE2
    $A: typeof $AxE2
    $toast: typeof $toast
    $util: typeof $util
    $appHook: typeof $AxE2.$appHook
    $axItemSearchHelper: typeof $axItemSearchHelper
    $itemFavoriteManager: typeof $itemFavoriteManager
  }
}

// @ts-ignore
window.$AxE2 = $AxE2

// @ts-ignore
window.AxEFeatureConfig = Object.assign({}, window.AxEFeatureConfig || {}, { useBirthdayIntoPasswordReminder: true })

document.addEventListener('DOMContentLoaded', function () {
  actions.executeInitEvents()
})

window.addEventListener('load', (event) => {
  setTimeout(() => {
    $AxE2Loader.load() // load all the element with specified class
    const e = new Event('$AxE2.scriptLoaded')
    window.dispatchEvent(e)

    actions.executeLoadEvents()
  }, 30)
})
